<script setup lang="ts">
import Back from '@pet/base.back/index.vue';
import { computed } from 'vue-demi';

import BackIcon from '../icons/back-icon.vue';
import ShareIcon from '../icons/share-icon.vue';
interface Props {
    title?: string;
    showBack?: boolean;
    background?: string;
    iconColor?: string;
    showShare?: boolean;
    beforeBack?: (() => void) | (() => Promise<void>);
    customBack?: () => void;
    displayFoldBar?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    title: '',
    background: '#fff',
    showBack: true,
    opacity: 0,
    iconColor: '',
    showShare: false,
    displayFoldBar: true,
});

const emit = defineEmits<{
    (event: 'share'): void;
}>();

function handleClick() {
    emit('share');
}

const foldBackground = computed(() => {
    return {
        background: props.background,
    };
});

const foldIconColor = computed(() => {
    return {
        color: props.iconColor,
    };
});
</script>

<template>
    <div class="fold-wrapper" :style="foldBackground">
        <div v-if="displayFoldBar" class="fold-main" :style="foldIconColor">
            <div class="fold-left">
                <Back v-if="showBack" :before-back="beforeBack" :custom-back="customBack">
                    <BackIcon class="fold-icon" />
                </Back>
                <slot v-else name="left-fold" />
            </div>
            <div class="fold-title">
                <template v-if="$slots['title-fold']">
                    <slot name="title-fold" />
                </template>
                <template v-else>
                    {{ title }}
                </template>
            </div>
            <div class="fold-right">
                <ShareIcon v-if="showShare" class="fold-icon" @click="handleClick" />
                <slot name="right-fold" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../var.scss';

.fold-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}
.fold-main {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: $fold-vertical-gap $fold-horizontal-gap;
    &:empty {
        display: none;
    }
}
.fold-icon {
    width: $fold-item-size;
    height: $fold-item-size;
    vertical-align: middle;
}
.fold-left,
.fold-right {
    flex-shrink: 0;
    width: $fold-item-size;
    height: $fold-item-size;
    white-space: nowrap;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
}

.fold-title {
    display: flex;
    justify-content: center;
    align-items: center;
    :deep(img) {
        vertical-align: top;
    }
}

.fold-title {
    font-size: $fold-title-font-size;
    font-weight: 700;
    width: 100%;
    height: $fold-item-size;
    position: relative;
}
</style>
